import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

export const AppPreset = definePreset(Material, {
  semantic: {
    primary: {
      50: '{violet.50}',
      100: '{violet.100}',
      200: '{violet.200}',
      300: '{violet.300}',
      400: '{violet.400}',
      500: '{violet.500}',
      600: '{violet.600}',
      700: '{violet.700}',
      800: '{violet.800}',
      900: '{violet.900}',
      950: '{violet.950}',
    },
  },

  /*   components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: '{primary.color}',
              hoverBackground: '{primary.hoverColor}',
              activeBackground: '{primary.activeColor}',
              borderColor: '{primary.color}',
              hoverBorderColor: '{primary.hoverColor}',
              activeBorderColor: '{primary.activeColor}',
              color: '{primary.contrastColor}',
              hoverColor: '{primary.contrastColor}',
              activeColor: '{primary.contrastColor}'
            }
          }
        }
      }
    }
  } */
});
